import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type { IApiGetAppResponseBody } from '../Apps';
import type {
  IApiActivateWPLeaderboardRequestBody,
  IApiActivateWPLeaderboardResponseBody,
} from './WPLeaderboardApi.types';

export class WPLeaderboardApi {
  public constructor(private client: ApiClient) {}

  public async activate(
    appId: string,
    body: IApiActivateWPLeaderboardRequestBody,
  ): Promise<IApiActivateWPLeaderboardResponseBody> {
    const request: IApiJsonRequest = {
      method: 'post',
      path: '/providers/leaderboardwp/setup',
      body,
    };

    const data =
      await this.client.fetchJsonStandardized<IApiGetAppResponseBody>(request, {
        appId,
      });

    return data;
  }
}
